import { render } from "./bookMark.vue?vue&type=template&id=4feba7f1"
import script from "./bookMark.vue?vue&type=script&lang=js"
export * from "./bookMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__